import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iInstalmentFormValues, getSummaryScreen } from '@services/InstalmentService';

function InstalmentStep13(): ReactElement {
  const { values }: { values: iInstalmentFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default InstalmentStep13;
